export default () => {
  /**
   * @param url // It will return dm new url if yo dont pass http url
   * @param params
   * @param googleLink // if true it will return google play or app store link
   * @param withEndpoint // if false it will not prepend the appUrl
   * @returns
   */
  const utmUrl = (
    baseUrl = '/register',
    params?: Record<string, string>,
    googleLink?: boolean
  ) => {
    const { public: config } = useRuntimeConfig()
    const utmStore = useUTMStore()
    const { getUtmState } = storeToRefs(utmStore)
    const route = useRoute()

    const content = {
      ...getUtmState.value,
      slug: route.path.toString()
    }

    const hpUrl = config.url
    const dmUrl = config.appUrl
    let url = baseUrl ?? dmUrl
    const external = baseUrl === '/register' || baseUrl === '/login'

    const urlBase = external ? dmUrl : hpUrl
    if (!url.startsWith('http')) {
      url = url.replaceAll('#(\\./)+#', '/')
      url = urlBase + url
    }

    const fullUrl = url

    // Parse the URL to handle existing query params
    const urlObj = new URL(fullUrl)

    if (googleLink) {
      const mergedParams = {
        ...content,
        slug: route.path.toString()
      }
      urlObj.searchParams.set(
        'referrer',
        new URLSearchParams(mergedParams).toString()
      )
      Object.entries(params || {}).forEach(([key, value]) => {
        if (value && value.length) {
          urlObj.searchParams.set(key, value)
        }
      })
    } else {
      // Merge existing params, provided params, UTM content, and slug
      const mergedParams = {
        ...Object.fromEntries(urlObj.searchParams.entries()),
        ...(params || {}),
        ...content,
        ip: undefined, // Ensure IP is not included
        slug: route.path.toString()
      }

      // Clear existing params and set merged ones
      urlObj.search = ''
      Object.entries(mergedParams).forEach(([key, value]) => {
        if (value && value.length) {
          urlObj.searchParams.set(key, value)
        }
      })
    }

    return urlObj.toString().startsWith(hpUrl)
      ? urlObj.toString().replace(hpUrl, '')
      : urlObj.toString()
  }

  const utmUrlWithCustomMetaData = (...args: Parameters<typeof utmUrl>) => {
    const route = useRoute()
    const customMetaData = route.meta.custom_meta_data as
      | Record<string, string>
      | undefined

    const newArgs = args
    if (customMetaData) {
      newArgs[1] = {
        ...customMetaData,
        ...(newArgs[1] || {})
      }
    }

    return utmUrl(...newArgs)
  }

  return {
    utmUrl,
    utmUrlWithCustomMetaData
  }
}
